var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ul",
    {
      staticClass:
        "pagination b-pagination pagination-md justify-content-center"
    },
    [
      _c(
        "li",
        {
          staticClass: "page-item page-btn fisrt",
          class: [{ disabled: _vm.currentPage === 1 }]
        },
        [
          _c(
            "a",
            {
              staticClass: "page-link",
              attrs: { href: "#" },
              on: {
                click: function($event) {
                  $event.preventDefault()
                  return _vm.changePage(1)
                }
              }
            },
            [_vm._v("≪")]
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "li",
        {
          staticClass: "page-item page-btn prev",
          class: [{ disabled: _vm.currentPage <= 1 }]
        },
        [
          _c(
            "a",
            {
              staticClass: "page-link",
              attrs: { href: "#" },
              on: {
                click: function($event) {
                  $event.preventDefault()
                  return _vm.changePage(
                    1 >= _vm.currentPage - 10 ? 1 : _vm.currentPage - 10
                  )
                }
              }
            },
            [_vm._v("\n      " + _vm._s(_vm.config.prevText) + "\n    ")]
          )
        ]
      ),
      _vm._v(" "),
      _vm._l(_vm.pages, function(num) {
        return _c(
          "li",
          {
            key: num,
            staticClass: "page-item",
            class: [{ active: num === _vm.currentPage }]
          },
          [
            _c(
              "a",
              {
                staticClass: "page-link",
                attrs: { href: "#" },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.changePage(num)
                  }
                }
              },
              [_vm._v("\n      " + _vm._s(num) + "\n    ")]
            )
          ]
        )
      }),
      _vm._v(" "),
      _c(
        "li",
        {
          staticClass: "page-item page-btn next",
          class: [{ disabled: _vm.currentPage > _vm.lastPage }]
        },
        [
          _c(
            "a",
            {
              staticClass: "page-link",
              attrs: { href: "#" },
              on: {
                click: function($event) {
                  $event.preventDefault()
                  return _vm.changePage(
                    _vm.currentPage > _vm.lastPage - 10
                      ? _vm.lastPage
                      : _vm.currentPage + 10
                  )
                }
              }
            },
            [_vm._v(_vm._s(_vm.config.nextText))]
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "li",
        {
          staticClass: "page-item page-btn end",
          class: [
            { disabled: _vm.currentPage === _vm.lastPage || _vm.lastPage === 0 }
          ]
        },
        [
          _c(
            "a",
            {
              staticClass: "page-link",
              attrs: { href: "#" },
              on: {
                click: function($event) {
                  $event.preventDefault()
                  return _vm.changePage(_vm.lastPage)
                }
              }
            },
            [_vm._v("≫")]
          )
        ]
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-44bf6089", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-44bf6089","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/control/pagination/Pagination.vue
// module id = null
// module chunks = 